// Export the DrawerComponent class for other modules to extend
export class DrawerComponent extends HTMLElement {
  constructor() {
    super();
    this.id = this.dataset.drawerId;
    console.log("==== drawer-component.js loaded ====", this.id);
    this.isOpen = this.classList.contains('is-open');
    this.overlay = this.querySelectorAll('[data-drawer-overlay]');
    this.window = this.querySelector('[data-drawer-window]');
    this.drawerOpener = document.querySelectorAll(`[data-drawer-trigger="${this.id}"]`);
    console.log("==== drawer-component.js loaded ====", this.id, this.drawerOpener);
    this.drawerOpener?.forEach(drawerOpener => {
      drawerOpener.addEventListener('click', this.toggleDrawer.bind(this));
    });
    
    document.addEventListener('keyup', (e) => {
      if (!this.isOpen) return
      if (e.key === 'Escape') {
        this.close()
      }
    })
    
    this.overlay?.forEach(overlay => {
      overlay.addEventListener('click', this.close.bind(this));
    });
  }

  toggleDrawer(event) {
    event.preventDefault();
    this.isOpen = !this.isOpen;
    this.isOpen ? this.open() : this.close();
  }

  close() {
    this.classList.remove('is-open');
    this.isOpen = false;
    document.body.classList.remove('overflow-hidden');
  }
  
  open() {
    this.classList.add('is-open');
    this.isOpen = true;
    if (document.documentElement.scrollHeight > document.documentElement.clientHeight) {
      document.body.classList.add('overflow-hidden');
    }
  }
}


// Only define custom element if not already defined
if (!customElements.get('drawer-component')) {
  customElements.define('drawer-component', DrawerComponent);
}


class DrawerClose extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.close.bind(this));
  }


  close() {
    const drawerId = this.dataset.drawerId;
    document.querySelector(`[data-drawer-id="${drawerId}"]`).close();
  }
}

if (!customElements.get('drawer-close')) {
  customElements.define('drawer-close', DrawerClose);
}

class ModalComponent extends DrawerComponent {
  constructor() {
    super();
  }
  
}

if (!customElements.get('modal-component')) {
  customElements.define('modal-component', ModalComponent);
}